<template>
  <div class="tickets-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">BOOKING TICKETS</h1>
        <div class="title-decoration"></div>
      </div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          placeholder="Search tickets..."
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="$bookingTickets"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear
          slot="progress"
          color="#587e27"
          indeterminate
          height="3"
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{ formated_date_time(props.item.date_created) }}</td>
          <td class="font-weight-medium">{{ props.item.name }}</td>
          <td>
            <v-btn
              depressed
              small
              color="#2196f3"
              class="futuristic-btn action-btn"
              @click="showTicket(props.item.url)"
            >
              View
            </v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Tickets',
  data () {
    return {
      search: '',
      columns: [
        {
          text: 'Added On',
          value: 'date_created',
          class: 'table-header'
        },
        {
          text: 'Ticket Reference',
          value: 'name',
          class: 'table-header'
        },
        {
          text: 'Action',
          value: '',
          class: 'table-header'
        }
      ]
    }
  },
  methods: {
    showTicket (url) {
      window.open(url, '_blank')
    }
  },
  created () {
    this.$store.dispatch('get_booking_tickets')
  }
}
</script>

<style scoped>
/* Futuristic Container */
.tickets-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.tickets-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .tickets-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-btn {
    margin: 2px;
  }
}

@media (max-width: 600px) {
  .tickets-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>